module.exports = __webpack_public_path__ + "img/Query4.2fb8a91f.png";